import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth/_services/auth.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms'
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardServicesService } from '../../../services/dashboard-services/dashboard-services.service';
import { runInThisContext } from 'vm';
import { Observable } from 'rxjs';
import { LoginService } from '../../../services/login/login.service'
import { PowerBILogService } from '../../../services/log/powerBILog.service';
import { Screen } from '../../../models/enums/screen.enum';
import { Jwk } from './interfaces/Jwk';
import { LoginResponse } from './interfaces/LoginResponse';
import { LoginFormValue } from './interfaces/LoginFormValue';
import { LoginPayload } from './interfaces/LoginPayload';

@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss',
    './css/bootstrap.min.css',
    './css/bootstrap.min.2.css',
    './css/bootstrap.min.3.css',
    './css/fonts.css',
    './css/icons.css',
    './css/media.css',
    './css/root.css']
})
export class LoginComponent implements OnInit {
  // ===== Auditoría =====
  screenId: any;
  module: any;
  clickEvent: any;
  action: any;
  objectType: any;
  objectName: any;
  subModule: any;
  refNumber: any;
  refType: any;

  // ===== UI =====
  hasError = false;
  errorMessage = '';
  submitted = false;
  isPasswordVisible = false;
  saveCredential = false;

  checkValidation = false;
  checkNull = false;

  // ===== Forms =====
  storageFormGroup!: FormGroup;
  userFormGroup!: FormGroup;

  //variables
  email: string = '';
  password: string = '';
  emailGuest: string = '';
  passwordGuest: string = '';

  private readonly EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';

  public orderInProgressList: any;
  public page: number = 1;
  public size: number = 10;

  constructor(private authService: AuthService,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private router: Router,
    private dashboardServices: DashboardServicesService,
    private loginService: LoginService,
    private powerBIService: PowerBILogService
  ) {
    this.isPasswordVisible = false
  }

  ngOnInit() {
    /*this.getform()*/
    this.generateForm()
    this.buildForms();
    this.getCookie()

    this.screenId = Screen.Recuperarcontrasena;
    this.module = 'Recuperar Contrasena';
    this.clickEvent = "Click";
    this.action = "Redirect";
    this.objectType = "Button";
    this.objectName = "IniciarSesion";
    this.subModule = null;
    this.integratedAuditAPI();
  }

  /*getform() {
    this.userFormGroup = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailPattern),
      ]),
      password: new FormControl('', [
        Validators.required
      ]),
    })
  }*/

  generateForm() {
    this.storageFormGroup = this.formBuilder.group({
      searchRecord: new FormControl('', [
        Validators.required,
      ])
    })
  }

  search() {
    this.orderInProgressList = '';
    if (this.storageFormGroup.invalid) {
      return
    } 
    else {
      let payload$ = {
        referenceNo: this.storageFormGroup.controls.searchRecord.value,
        referenceType: 'bl',
        orderOn: 'dt',
        orderBy: 'desc',
        startWith: this.search
      }
      this.dashboardServices.getOrderInProgressList(this.page, this.size, payload$).subscribe(response => {
        debugger
        this.orderInProgressList = response.orders
        if (this.orderInProgressList.length > 0) {
          this.router.navigate(['order/' + this.storageFormGroup.controls.searchRecord.value]);
        }
        this.checkValidation = true;
        this.checkNull = true;
        this.cd.detectChanges();
      })
    }
    this.action = "Search";
    this.objectType = "Button";
    this.objectName = "SearchAsGuest";
    this.refNumber = this.storageFormGroup.controls.searchRecord.value;
    this.refType = 'bl';
    this.subModule = 'Buscar "as a guest"';
    this.integratedAuditAPI();
  }

  /*showPassword() {
    this.isPasswordVisible = !this.isPasswordVisible
  }*/

  private buildForms(): void {
    this.storageFormGroup = this.formBuilder.group({
      searchRecord: new FormControl('', Validators.required)
    });

    this.userFormGroup = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(this.EMAIL_PATTERN)
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ])
    });
  }

  getCookie() {
    const username = ('; ' + document.cookie).split(`; username=`).pop().split(';')[0];
    const password = ('; ' + document.cookie).split(`; password=`).pop().split(';')[0];
    const checked = ('; ' + document.cookie).split(`; checked=`).pop().split(';')[0];
    this.saveCredential = checked == 'true' ? true : false;
    if (username && password) {
      this.email = username
      this.password = password
    }
  }

  setCookie(event: any): void {
    this.saveCredential = event.target.checked;

    if (this.saveCredential) {
      const email = this.userFormGroup.value.email || '';
      document.cookie = `username=${encodeURIComponent(email)}; path=/; SameSite=Lax`;
      document.cookie = `checked=true; path=/; SameSite=Lax`;
    } else {
      document.cookie = `username=; Max-Age=0; path=/; SameSite=Lax`;
      document.cookie = `checked=false; path=/; SameSite=Lax`;
    }
  }

  private showErrorMessage(message: string) {
    this.errorMessage = message
    this.hasError = true
    this.cd.detectChanges();
  }

  showPassword(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  // ============================
  // Login Invitado
  // ============================
  async loginInvitado(): Promise<void> {
    localStorage.removeItem('Selectedcompany');
    this.submitted = true;

    this.emailGuest = "userguest@mardom.com";
    this.passwordGuest = "PasswordGuest-001";
    
    localStorage.setItem('email', this.emailGuest);

    try {
      const jwk = await this.getPublicKey();
      const resp = await this.loginEncrypted(this.emailGuest, this.passwordGuest, jwk);

      this.authService.setLoginDetailsGuest(resp);
      this.logAuditLoginGuest();
      this.search()
    } catch (err) {
      this.handleLoginError(err);
    }
  }

  // ============================
  // Login
  // ============================
  async login(): Promise<void> {
    localStorage.removeItem('Selectedcompany');
    this.submitted = true;

    //if (this.userFormGroup.invalid) return;

    if (this.userFormGroup.invalid) {
      this.userFormGroup.markAllAsTouched();
      return;
    }

    const { email, password } = this.userFormGroup.value as LoginFormValue;
    
    localStorage.setItem('email', email);

    try {
      const jwk = await this.getPublicKey();
      const resp = await this.loginEncrypted(email, password, jwk);

      this.authService.setloginDetails(resp);
      this.logAuditLogin();
    } catch (err) {
      this.handleLoginError(err);
    }
  }

  private async getPublicKey(): Promise<Jwk> {
    return this.toPromiseSafe(this.loginService.publicKey(), 'No se pudo obtener la llave pública');
  }

  private async loginEncrypted(email: string, password: string, jwk: Jwk): Promise<any> {
    const payload: LoginPayload = {
      email,
      password,
      ts: new Date().toISOString(),
      nonce: this.generateNonce()
    };

    const cipherTextB64 = await this.encryptLoginPayload(jwk, payload);

    return this.toPromiseSafe(this.loginService.descryptApi(cipherTextB64), 'Login falló');
  }

  private logAuditLoginGuest(): void{
    this.action = "Redirect";
    this.objectType = "Button";
    this.objectName = "LoginMardomGo";
    this.subModule = "Usuario Invitado";
    this.integratedAuditAPI();
  }
  
  private logAuditLogin(): void {
    this.action = 'Redirect';
    this.objectType = 'Button';
    this.objectName = 'LoginMardomGo';
    this.subModule = 'Entrar al Portal';
    this.integratedAuditAPI();
  }

  private handleLoginError(err: any): void {
    const msg = (err && err.message) ? err.message : 'Ocurrió un error en el login';
    this.showErrorMessage(msg);
  }

  private generateNonce(): string {
    const buf = new Uint32Array(4);
    crypto.getRandomValues(buf);
    return Array.from(buf).join('-');
  }

  private toPromiseSafe<T>(obs: any, defaultMessage: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      obs.subscribe(
        (value: T) => resolve(value),
        (error: any) => reject(new Error(this.extractErrorMessage(error, defaultMessage)))
      );
    });
  }

  private extractErrorMessage(error: any, fallback: string): string {
    return error.error.description || error.error.message || error.message || fallback;
  }

  async encryptLoginPayload(jwk: Jwk, payload: LoginPayload): Promise<string> {
    const key = await this.importRsaPublicKeyFromJwk(jwk);
    const data = new TextEncoder().encode(JSON.stringify(payload));

    const cipherBuf = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, key, data);
    return this.bytesToBase64(new Uint8Array(cipherBuf));
  }

  async importRsaPublicKeyFromJwk(jwk: Jwk): Promise<CryptoKey> {
    return crypto.subtle.importKey(
      'jwk',
      {
        kty: jwk.kty,
        n: jwk.n,
        e: jwk.e,
        alg: 'RSA-OAEP-256',
        ext: true,
        key_ops: ['encrypt']
      } as any,
      { name: 'RSA-OAEP', hash: 'SHA-256' },
      false,
      ['encrypt']
    );
  }

  bytesToBase64(bytes: Uint8Array): string {
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize) as any);
    }
    return btoa(binary);
  }

  hideErrorMessage() {
    this.hasError = false
  }

  // ============================
  // Auditoría
  // ============================
  integratedAuditAPI(): void {
    this.powerBIService.createPayload(
      this.screenId,
      this.module,
      this.clickEvent,
      this.action,
      this.objectType,
      this.objectName,
      this.refNumber,
      this.refType,
      this.subModule
    );
  }
}
